import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import './SystemMonitor.css';
import EmailLogs from '../components/monitoring/EmailLogs';
import SystemLogs from '../components/monitoring/SystemLogs';
import SystemHealth from '../components/monitoring/SystemHealth';

const SystemMonitor = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('email-logs');

  const isSuperAdmin = ['super_admin', 'super_user'].includes(user?.role);
  const isAdmin = ['admin', 'super_admin', 'super_user'].includes(user?.role);

  if (!isAdmin) {
    return (
      <div className="app-container">
        <Header />
        <Navigation activeTab="system-monitor" />
        <div className="content">
          <div className="unauthorized-message">
            <h2>Access Denied</h2>
            <p>You do not have permission to access the System Monitor.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <Header />
      <Navigation activeTab="system-monitor" />
      <div className="content">
        <div className="system-monitor">
          <div className="monitor-header">
            <h1>System Monitor</h1>
            <p className="monitor-subtitle">Monitor system health, email notifications, and logs</p>
          </div>

          <div className="monitor-tabs">
            <button
              className={`tab-button ${activeTab === 'email-logs' ? 'active' : ''}`}
              onClick={() => setActiveTab('email-logs')}
            >
              📧 Email Logs
            </button>

            {isSuperAdmin && (
              <>
                <button
                  className={`tab-button ${activeTab === 'system-logs' ? 'active' : ''}`}
                  onClick={() => setActiveTab('system-logs')}
                >
                  📄 System Logs
                </button>

                <button
                  className={`tab-button ${activeTab === 'system-health' ? 'active' : ''}`}
                  onClick={() => setActiveTab('system-health')}
                >
                  💚 System Health
                </button>
              </>
            )}
          </div>

          <div className="monitor-content">
            {activeTab === 'email-logs' && <EmailLogs isSuperAdmin={isSuperAdmin} />}
            {activeTab === 'system-logs' && isSuperAdmin && <SystemLogs />}
            {activeTab === 'system-health' && isSuperAdmin && <SystemHealth />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemMonitor;
